import { useNavigate } from 'react-router-dom'
import { ResetPasswordScreen } from '@rammetec/design-system/templates'
import { authService } from '@/authService'

export function ResetPasswordPage() {
  const navigate = useNavigate()

  return (
    <ResetPasswordScreen
      brandName="VectorHub"
      title="Recuperar senha"
      onSubmit={async ({ email }) => {
        await authService.sendPasswordResetEmail(email)
      }}
      onBackToLogin={() => navigate('/login')}
    />
  )
}
